import useTrackDocuments from "@/modules/property-tracks/hooks/use-track-documents.hook";
import { Track } from "@/modules/property-tracks/types";
import { useMemo } from "react";
import DocumentCategoryCard from "./document-category-card";
import useTrackDocumentTypes from "@/modules/common/hooks/document-types.hook";
import useTrackContracts from "@/modules/property-tracks/hooks/use-track-contracts.hook";
import { ContractListItem } from "@/modules/property-tracks/dtos/contracts/index";
import GeneratedContractsCard from "./generated-contracts-card";
import { PROPERTY_TRACKS } from "@/modules/property-tracks/utils";

const DocumentsList = ({ track }: { track: Track }) => {
  const { data } = useTrackDocuments({
    trackId: track.uid,
  });

  const trackTypeName = track.trackType.name;

  const { data: cmbContracts } = useTrackContracts({
    propertyUid: track.property.uid,
    type: trackTypeName as PROPERTY_TRACKS,
  });

  const documentTypes = useTrackDocumentTypes(track.trackType.id).filter(
    (v) => v !== "Media" && v !== "MaterialSelection"
  );
  const documentCategories = useMemo(() => {
    if (!data) return [];

    return documentTypes.map((documentType) => ({
      documentType,
      documents: data.filter((doc) => doc.documentType === documentType),
    }));
  }, [data, documentTypes]);

  const isFinishingTrack = trackTypeName === PROPERTY_TRACKS.FINISHING;

  const currentOwner = useMemo(() => {
    return track.property.customerProperty?.find(
      (cp) => cp.currentOwner === true
    );
  }, [track.property.customerProperty]);

  const customerUid = currentOwner?.customer?.uid;

  return (
    <>
      <GeneratedContractsCard
        contracts={cmbContracts as ContractListItem[]}
        isFinishingTrack={isFinishingTrack}
        propertyUid={track.property.uid}
        customerUid={customerUid}
      />
      {documentCategories.map((category) => (
        <DocumentCategoryCard
          key={category.documentType}
          documentType={category.documentType}
          documents={category.documents}
        />
      ))}
    </>
  );
};

export default DocumentsList;
